import './styles.scss';
import { SITE_URL } from '@/constants/constants';

export default {
    name: 'StorageSyncPage',

    data() {
        return {
            menu: [
                {
                    detail: false,
                    button: true,
                    text: 'Profile',
                    url: '/account/profile'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Buildings',
                    url: '/account/subscriptions'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Sync',
                    url: '/account/storage-sync'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Privacy Policy',
                    url: `${SITE_URL}/privacy-policy`
                }
            ]
        }
    },

    computed: {
        documents_syncing() {
            return this.$store.getters.getDocumentSyncing;
        },
        online() {
            return this.$store.getters.getOffline;
        },
        article_list() {
            return this.$store.getters.getSubArticles;
        },
        articles_syncing() {
            return this.$store.getters.getArticlesSyncing;
        },
        missing_articles() {
            return this.$store.getters.getMissingArticles;
        },
        cached_list() {
            return this.$store.getters.getArticleCache;
        },
        article_errors() {
            return this.$store.getters.getArticleSkip;
        },
        cached_count() {
            return this.cached_list.length;
        },
        articles_count() {
            return this.article_list.length;
        },
        document_list() {
            return this.$store.getters.getDocumentsList('preplans');
        },
        document_count() {
            return this.document_list.length;
        },
        document_cache() {
            return this.$store.getters.getCachedDocumentsList;
        },
        missing_documents() {
            return this.$store.getters.getMissingDocuments;
        }
    },

    watch: {
        online(newValue, oldValue) {
            if (newValue) {
                this.$store.dispatch('checkSubscriptionCache');
            }
            if (newValue) {
                this.$store.dispatch('checkDocumentsCache');
            }
        }
    },

    created() {
        this.$store.dispatch('checkOnlineStatus');
        this.$store.dispatch('checkSubscriptionCache');
        this.$store.dispatch('checkDocumentsCache');
        this.$store.commit('setMenuItems', this.menu);
        this.$store.commit('setMenuDetails', { title: 'Account', slug: 'account' });
    },

    methods: {
        fetchMissing() {
            this.$store.dispatch('checkSubscriptionCache');
            this.$ionic.alertController.create({
                message: "Content will be fetched in the background, so continue to use the app. Closing the application or switching to another application will stop content from being retrieved.",
                buttons: ['OK']
            }).then(a => a.present());
        },
        fetchDocuments() {
            this.$store.dispatch('checkDocumentsCache');
            this.$ionic.alertController.create({
                message: "Content will be fetched in the background, so continue to use the app. Closing the application or switching to another application will stop content from being retrieved.",
                buttons: ['OK']
            }).then(a => a.present());
        },
        fetchNew() {
            this.$store.dispatch('updateData');
            this.$ionic.alertController.create({
                message: "Content will be fetched in the background, so continue to use the app. Closing the application or switching to another application will stop content from being retrieved.",
                buttons: ['OK']
            }).then(a => a.present());
        }
    }
};